import React from 'react'

// IBS/CBS monofásico (combustível) — grupo gIBSCBSMono do XML; base = quantidade x R$ por unidade.
export interface IbsCbsMonoLinha {
  modalidade: 'P' | 'R' | 'A' | 'D'
  quantidade: number
  adRemIbs: number; adRemCbs: number
  valorIbs: number; valorCbs: number
  percDifIbs: number; percDifCbs: number
}

const NOME_MODALIDADE: Record<string, string> = {
  P: 'Padrão', R: 'Sujeita à retenção', A: 'Retida anteriormente', D: 'Diferimento',
}

const fmt = (v: number, casas = 2) => v.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas })

export function AbasIbsCbs({ aba, onChange, cor = '#1a6ea8' }: { aba: 'regular' | 'mono'; onChange: (a: 'regular' | 'mono') => void; cor?: string }) {
  const botao = (id: 'regular' | 'mono', rotulo: string) => (
    <button type="button" onClick={() => onChange(id)} style={{
      padding: '5px 14px', fontSize: '0.72rem', cursor: 'pointer', marginBottom: -1,
      border: '1px solid #c4d8e4', borderBottomColor: aba === id ? '#fff' : '#c4d8e4', borderRadius: '6px 6px 0 0',
      background: aba === id ? '#fff' : '#eef4f8', color: aba === id ? cor : '#4b6475', fontWeight: aba === id ? 700 : 500,
    }}>{rotulo}</button>
  )
  return (
    <div style={{ display: 'flex', gap: 3, borderBottom: '1px solid #c4d8e4', margin: '0.4rem 0 0.4rem', width: '100%' }}>
      {botao('regular', 'Tributação regular')}
      {botao('mono', 'Tributação monofásica')}
    </div>
  )
}

export function TabelaIbsCbsMono({ linhas, unidade, cor = '#1a6ea8' }: { linhas: IbsCbsMonoLinha[]; unidade?: string; cor?: string }) {
  const un = (unidade || '').trim() || 'un'
  const td: React.CSSProperties = { padding: '3px 6px', border: '1px solid #d8e3eb', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }
  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.76rem' }}>
        <thead>
          <tr style={{ background: cor }}>
            {['Modalidade', 'Quantidade', `IBS R$/${un}`, 'Valor IBS', `CBS R$/${un}`, 'Valor CBS'].map(h => (
              <th key={h} style={{ padding: '4px 6px', border: `1px solid ${cor}`, color: '#fff', fontSize: '0.64rem', textTransform: 'uppercase', textAlign: h === 'Modalidade' ? 'left' : 'right' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {linhas.map(l => (
            <tr key={l.modalidade}>
              <td style={{ ...td, textAlign: 'left', fontWeight: 700 }}>{NOME_MODALIDADE[l.modalidade] || l.modalidade}</td>
              <td style={td}>{l.modalidade === 'D' ? '—' : fmt(l.quantidade, 4)}</td>
              <td style={td}>{l.modalidade === 'D' ? `${fmt(l.percDifIbs, 4)}% dif.` : fmt(l.adRemIbs, 4)}</td>
              <td style={{ ...td, fontWeight: 700 }}>{fmt(l.valorIbs)}</td>
              <td style={td}>{l.modalidade === 'D' ? `${fmt(l.percDifCbs, 4)}% dif.` : fmt(l.adRemCbs, 4)}</td>
              <td style={{ ...td, fontWeight: 700 }}>{fmt(l.valorCbs)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
